<template>
  <div class="auth-page">
    <div class="auth-container">
      <div class="auth-card">
        <div class="auth-header">
          <a href="/" class="logo-link">
            <img src="/static/favicon/favicon-76x76.png" alt="Logo" class="logo">
          </a>
          <h2 class="auth-title">Welcome Back</h2>
          <p class="auth-subtitle">Sign in to continue trading</p>
        </div>

        <div class="auth-body">
          <form onsubmit="return false;">
            <div class="form-group">
              <label for="email">Email</label>
              <div class="input-wrapper">
                <i class="bi bi-envelope"></i>
                <input v-model="email" type="email" id="email" placeholder="Enter your email" required>
              </div>
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <div class="input-wrapper">
                <i class="bi bi-lock"></i>
                <input v-model="password" type="password" id="password" placeholder="Enter your password" required>
              </div>
            </div>
            <p class="error-msg" v-if="errorMsg">{{ errorMsg }}</p>
            <button type="submit" class="btn-primary-auth" @click="signIn">
              <span>Sign In</span>
              <i class="bi bi-arrow-right"></i>
            </button>
          </form>

          <div class="divider" v-if="!isApp">
            <span>or continue with</span>
          </div>

          <div id="g_id_onload" v-if="!isApp"
              data-client_id="815898526228-o18ms44nkoj5c5he3j830movqfpa6qej.apps.googleusercontent.com"
              data-context="signin"
              data-ux_mode="popup"
              data-callback="onSignIn"
              data-auto_select="true"
              data-itp_support="true">
          </div>

          <div class="social-login" v-if="!isApp">
            <div class="g_id_signin d-flex justify-content-center"
                data-type="standard"
                data-shape="rectangular"
                data-theme="outline"
                data-text="signin_with"
                data-size="large"
                data-logo_alignment="left">
            </div>
          </div>
        </div>

        <div class="auth-footer">
          <a class="footer-link" @click="otpModal = true">Forgot password?</a>
          <div class="signup-prompt">
            Don't have an account?
            <a @click="$router.push('/signup')">Sign Up</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Forgot Password Modal -->
    <div class="modal-overlay" v-if="otpModal" @click.self="otpModal = false; errorMsg2 = ''">
      <div class="modal-container">
        <div class="modal-header">
          <h5>Reset Password</h5>
          <button type="button" class="btn-close" @click="otpModal = false; errorMsg2 = ''" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form onsubmit="return false;">
            <p class="error-msg" v-if="errorMsg2 && !changed">{{ errorMsg2 }}</p>
            <p class="success-msg" v-if="changed">Password changed successfully!</p>

            <div class="form-group" v-if="!changed">
              <label>Email address</label>
              <div class="input-with-btn">
                <input v-model="emailreset" type="email" placeholder="Enter your email" required>
                <button type="button" class="btn-send-otp" @click="sendOtp">Send OTP</button>
              </div>
            </div>

            <div class="form-group" v-if="otp">
              <label>Enter 6-digit OTP</label>
              <input type="text" v-model="otpe" class="otp-input" maxlength="6" pattern="\d{6}" placeholder="------" required>
            </div>

            <div class="form-group" v-if="otp">
              <label>New Password</label>
              <input v-model="passwordN" type="password" placeholder="Enter your new password" required>
            </div>

            <button v-if="otp" type="button" class="btn-primary-auth" @click="forgotPassword">Reset Password</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authGoogle, signIn, userresend, forgotPassword } from '@/service/restService'

export default {
  name: 'SignIn',
  props: {

  },
  data () {
    return {
      email: '',
      password: '',
      errorMsg: '',
      errorMsg2: '',
      otpModal: false,
      emailreset: '',
      passwordN: '',
      otp: false,
      otpe: '',
      changed: false,
      isApp: false
    }
  },
  created () {
    // if (window.google && !document.getElementById('g_id_onload')) {
    //   this.$router.go(0)
    // }

    this.isApp = this.isWebView()
    window.onSignIn = user => {
      this.googleLogin(user)
    }
  },
  methods: {
    forgotPassword: function () {
      if (!this.emailreset.match('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}')) {
        this.errorMsg2 = 'Please enter a valid email address'
        return
      }
      if (!this.passwordN) {
        this.errorMsg2 = 'Please enter your password'
        return
      }
      if (this.passwordN.length < 6) {
        this.errorMsg2 = '"Your password needs to be between 6 and 20 characters long'
        return
      }
      var obj = {email: this.emailreset,
        otp: this.otpe,
        password: this.passwordN }
      this.errorMsg2 = ''
      forgotPassword(obj).then((response) => {
        this.otp = false
        this.changed = true
      }).catch((error) => {
        this.errorMsg2 = error.response.data.message[0]
      })
    },
    sendOtp: function () {
      if (!this.emailreset.match('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}')) {
        this.errorMsg2 = 'Please enter a valid email address'
        return
      }
      var obj = {uuid: this.emailreset}
      this.errorMsg2 = ''
      userresend(obj).then((response) => {
        this.otp = true
        this.errorMsg2 = 'Otp has been sent to ' + this.emailreset
      }).catch((error) => {
        this.errorMsg2 = error.response.data.message[0]
      })
    },
    googleLogin (response) {
      var obj = {token: response.credential}
      authGoogle(obj).then((response) => {
        this.errorMsg = ''
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('refreshToken', response.data.refreshToken)
        localStorage.setItem('expiryEpoch', response.data.expiryEpoch)
        if (this.isMobile()) {
          this.$router.push('/mw')
        } else {
          this.$router.push('/orders')
        }
      }).catch((error) => {
        this.errorMsg = error.response.data.message[0]
      })
    },
    signIn: function () {
      this.errorMsg = ''
      if (!this.email) {
        this.errorMsg = 'Please enter your email Id'
        return
      }
      if (!this.email.match('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}')) {
        this.errorMsg = 'Please enter a valid email address'
        return
      }
      if (!this.password) {
        this.errorMsg = 'Please enter your password'
        return
      }
      if (this.password.length < 6) {
        this.errorMsg = '"Your password needs to be between 6 and 20 characters long'
        return
      }
      var obj = { password: this.password, emailId: this.email }
      signIn(obj).then((response) => {
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('refreshToken', response.data.refreshToken)
        localStorage.setItem('expiryEpoch', response.data.expiryEpoch)
        if (this.isMobile()) {
          this.$router.push('/mw').then(() => {
            window.location.reload()
          })
        } else {
          this.$router.push('/orders')
        }
        this.errorMsg = ''
      }).catch((error) => {
        this.errorMsg = error.response.data.message[0]
      })
    }
  }
}
</script>
<style scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.auth-container {
  width: 100%;
  max-width: 420px;
}

.auth-card {
  background: var(--bs-body-bg);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.auth-header {
  text-align: center;
  padding: 30px 30px 20px;
}

.logo-link {
  display: inline-block;
  margin-bottom: 16px;
}

.logo {
  width: 60px;
  height: 60px;
  border-radius: 12px;
}

.auth-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--bs-body-color);
  margin: 0 0 8px;
}

.auth-subtitle {
  font-size: 14px;
  color: var(--bs-secondary-color);
  margin: 0;
}

.auth-body {
  padding: 0 30px 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--bs-body-color);
  margin-bottom: 6px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-wrapper i {
  position: absolute;
  left: 14px;
  color: var(--bs-secondary-color);
  font-size: 16px;
}

.input-wrapper input {
  width: 100%;
  padding: 12px 14px 12px 42px;
  border: 1px solid var(--bs-border-color);
  border-radius: 10px;
  font-size: 14px;
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.input-wrapper input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.error-msg {
  color: #dc3545;
  font-size: 13px;
  margin: 8px 0;
}

.success-msg {
  color: #0BDA51;
  font-size: 13px;
  margin: 8px 0;
}

.btn-primary-auth {
  width: 100%;
  padding: 12px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn-primary-auth:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.divider {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--bs-border-color);
}

.divider span {
  padding: 0 12px;
  font-size: 12px;
  color: var(--bs-secondary-color);
}

.social-login {
  margin-top: 16px;
}

.auth-footer {
  padding: 20px 30px;
  background: var(--bs-tertiary-bg);
  text-align: center;
}

.footer-link {
  color: #667eea;
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
}

.footer-link:hover {
  text-decoration: underline;
}

.signup-prompt {
  margin-top: 12px;
  font-size: 13px;
  color: var(--bs-secondary-color);
}

.signup-prompt a {
  color: #667eea;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}

.signup-prompt a:hover {
  text-decoration: underline;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-container {
  background-color: var(--bs-body-bg);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 420px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--bs-border-color);
}

.modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--bs-body-color);
}

.modal-body {
  padding: 24px;
}

.modal-body .form-group input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--bs-border-color);
  border-radius: 10px;
  font-size: 14px;
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
}

.modal-body .form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.input-with-btn {
  display: flex;
  gap: 10px;
}

.input-with-btn input {
  flex: 1;
}

.btn-send-otp {
  padding: 10px 16px;
  background: #667eea;
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.btn-send-otp:hover {
  background: #5a6fd6;
}

.otp-input {
  text-align: center;
  letter-spacing: 8px;
  font-size: 18px;
  font-weight: 600;
}

/* Mobile Responsive */
@media (max-width: 480px) {
  .auth-page {
    padding: 15px;
  }

  .auth-header {
    padding: 24px 20px 16px;
  }

  .auth-body {
    padding: 0 20px 16px;
  }

  .auth-footer {
    padding: 16px 20px;
  }

  .logo {
    width: 50px;
    height: 50px;
  }

  .auth-title {
    font-size: 20px;
  }

  .input-with-btn {
    flex-direction: column;
  }

  .btn-send-otp {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/SignIn.vue